import { Routes } from '@angular/router';

export const PUBLIC_ROUTES: Routes = [
    { path: 'users', loadChildren: () => import('src/app/user/user.module').then(x => x.UserModule) },
    { path: '', redirectTo: 'users/login', pathMatch: 'full' },
];
